import posthog from 'posthog-js'

import type { IAnalyticsProperties, IAnalyticsWorkspace } from '../types/analytics'

export const ANALYTICS_READY_EVENT = 'chain:analytics-ready'

export const isAnalyticsReady = (): boolean => {
  return typeof window !== 'undefined' && posthog.__loaded
}

export const identify = (userId: string, properties?: Record<string, string>): void => {
  if (!isAnalyticsReady()) return
  posthog.identify(userId, properties)
}

export const captureEvent = (eventName: string, properties?: IAnalyticsProperties): void => {
  if (!isAnalyticsReady()) return
  posthog.capture(eventName, properties)
}

/**
 * Associate the current user session with a workspace (PostHog group).
 * Uses posthog.group() so all subsequent events in the session are attributed to this workspace.
 * Call when the selected workspace changes (e.g. in AnalyticsProvider).
 */
export const identifyWorkspace = (workspace: IAnalyticsWorkspace): void => {
  if (!isAnalyticsReady()) return
  posthog.group('workspace', workspace.id, {
    display_name: workspace.displayName,
    is_verified: workspace.isVerified,
    name: workspace.workspacename,
    workspace_id: workspace.id
  })
}

export const isFeatureEnabled = (flag: string): boolean => {
  if (!isAnalyticsReady()) return false
  return posthog.isFeatureEnabled(flag) ?? false
}

export const setUserProperty = (property: string | IAnalyticsProperties, value?: string): void => {
  if (!isAnalyticsReady()) return
  posthog.people.set(property, value)
}

export const reset = (): void => {
  if (!isAnalyticsReady()) return
  posthog.reset(true)
}
